export const CHANAKYA_COLORS = {
  primary: '#303F9F',
  primaryDark: '#1A237E',
  accent: '#A6763B',
  accentDark: '#6D4C1F',
  parchment: '#F5ECD9',
  cellBg: '#FAF4E8',
  cellBorder: 'rgba(48, 63, 159, 0.25)',
  tappedBg: '#E8DFC8',
  tappedBorder: '#A6763B',
  pulseGlow: 'rgba(166, 118, 59, 0.5)',
  textPrimary: '#2C1810',
  textSecondary: '#6D5A3D',
};

export const CHANAKYA_GRID_PALETTE = {
  cellBg: CHANAKYA_COLORS.cellBg,
  cellBorder: CHANAKYA_COLORS.cellBorder,
  tappedBg: CHANAKYA_COLORS.tappedBg,
  tappedBorder: CHANAKYA_COLORS.tappedBorder,
  pulseColor: CHANAKYA_COLORS.pulseGlow,
  primaryColor: CHANAKYA_COLORS.textPrimary,
  secondaryColor: CHANAKYA_COLORS.textSecondary,
};

export const THEME_ACCENT_COLORS = {
  business: '#A6763B',
  relationships: '#6D4C5E',
  governance: '#303F9F',
  self_discipline: '#4E6E3B',
  strategy: '#455A64',
  ethics: '#8D4C4C',
};
